(function () {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderDetailController', AppraisalOrderDetailController);

    AppraisalOrderDetailController.$inject = ['$q', '$sce', '$scope', '$rootScope', '$state', '$mdDialog', '$filter', '$window', '$http', '$timeout', 'entity', 'account', 'Principal',
        'AppraisalOrder', 'AppraisalReport', 'File', 'AppraisalOrderContact', 'QuoteSplit', 'AlertService', 'Quote', 'AppraisalOrderChangeRequest',
        'QuoteSplitModalService', 'AppraisalOrderModal', 'Blob', 'FileSaver', 'moment', 'AppraisalState', 'Coupon', 'AppraisalNote', 'VCNote',
        'LenderIntegrationBlacklist', 'User', 'daysAfterPayment', 'Invoice', 'InvoiceUtils', 'Brokerage', 'BrokerageLocation', 'BrokerageRegion', 'Lender', 'LenderContact', 'ProfileService'];

    function AppraisalOrderDetailController($q, $sce, $scope, $rootScope, $state, $mdDialog, $filter, $window, $http, $timeout, entity, account, Principal,
                                            AppraisalOrder, AppraisalReport, File, AppraisalOrderContact, QuoteSplit, AlertService, Quote, AppraisalOrderChangeRequest,
                                            QuoteSplitModalService, AppraisalOrderModal, Blob, FileSaver, moment, AppraisalState, Coupon, AppraisalNote, VCNote,
                                            LenderIntegrationBlacklist, User, daysAfterPayment, Invoice, InvoiceUtils, Brokerage, BrokerageLocation, BrokerageRegion, Lender, LenderContact, ProfileService) {

        var vm = this;
        var v2OrderBaseUrl = '';

        ProfileService.getProfileInfo().then(function(response) {
            v2OrderBaseUrl = response.v2OrderBaseUrl || '';
        });
        vm.appraisalOrder = entity;
        vm.daysAfterPayment = daysAfterPayment;
        vm.activeReport = vm.appraisalOrder.appraisalReports.find(function (report) {
            return report.id === vm.appraisalOrder.activeReport.id;
        });
        vm.checkAssigned = checkAssigned;
        vm.isAssigned = checkAssigned();
        vm.isAppraiser = Principal.hasAnyAuthority([/^ROLE_(APPRAISER|APPRAISAL).*/]);
        vm.isVC = Principal.hasAnyAuthority([/^ROLE_(ADMIN|VC|CUSTOMER_CARE).*/]);
        vm.isAdmin = Principal.hasAnyAuthority([/^ROLE_(ADMIN).*/]);
        vm.reportAvailability = null;
        vm.isCosigner = vm.activeReport && account.appraiserUser && vm.activeReport.cosignerId === account.appraiserUser.id;
        // vm.isThirdParty = vm.activeReport.forms.length === 1 && vm.activeReport.forms[0].fieldName === 'thirdParty';
        // Reports retain other forms if you ever switch off of third party and back. Changed to a function
        vm.isThirdParty = isThirdParty();
        vm.canSwitchToThirdParty = vm.isAssigned && inState('editable') && !vm.isThirdParty;
        // A Gnowise AVM has no appraiser, no visit and no property questionnaire, so this page hides its
        // appraiser, messaging, client-contact and property-information surfaces for one. The flag is
        // emitted by the server (AppraisalOrderDisplayDTO.gnowiseAvm) rather than derived here: the enum
        // knows which of the six AVM types are Gnowise, and a legacy Opta AVM must not be caught by it.
        vm.isGnowiseAvm = vm.appraisalOrder.gnowiseAvm === true;
        // Any AVM coverage, Gnowise or legacy Opta — neither has an appraiser, which is what the appraiser
        // fee / assignment / report actions on this page are gating on.
        //
        // Both fields are checked, mirroring the backend's OrderSummaryActionContext#appraisalTypeStringIncludesAvM,
        // which concatenates the two and looks for "AVM". They carry it independently: appraisalTypeOptions
        // is the coverage (AVM_VALUATION, AVM_BASIC, ...) and appraisalType is the purpose, which has its own
        // AVM constant that the order form sets for every AVM order. Testing only one is how a gate ends up
        // depending on which of the two a given caller happened to populate.
        //
        // Computed once here rather than inline per template, so an undefined value cannot throw inside an
        // Angular expression and the ten gates below cannot drift apart.
        vm.isAnyAvm = ((vm.appraisalOrder.appraisalTypeOptions || '') + (vm.appraisalOrder.appraisalType || ''))
            .includes('AVM');
        // Only the ENRICHED profile collects property attributes worth showing; ESSENTIALS and ADJUSTED
        // send almost nothing, so there is no section to render for them.
        vm.avmPropertyDetails = buildAvmPropertyDetails(vm.appraisalOrder.avmDetails);
        vm.showDetails = true;
        vm.entitiesLoaded = false;
        vm.printLogData = printLogData;
        vm.showLogDetails = showLogDetails;
        //Used for toggling email log entries details
        vm.logToggle = [];
        vm.detailedLogTypes = ['EMAIL'];
        vm.isIntegrationOrder = null;
        vm.purchaseClosingDate = vm.appraisalOrder.purchaseClosingDate != null ? vm.appraisalOrder.purchaseClosingDate.split('T')[0] : vm.appraisalOrder.purchaseClosingDate;
        vm.navigateToEditOrder = navigateToEditOrder;
        vm.placeholderLenderOptions = getPlaceholderLenderOptions();
        vm.copyOrderDetails = copyOrderDetails;
        vm.copyPlootoDetails = copyPlootoDetails;
        vm.copyClientContactDetails = copyClientContactDetails;
        vm.copyPropertyAccessContactDetails = copyPropertyAccessContactDetails;
        vm.copyUnderwriterContactDetails = copyUnderwriterContactDetails;
        vm.resendClientPaymentEmail = resendClientPaymentEmail;
        vm.submittingAgentBrokerage = fetchSubmittingAgentBrokerage();
        vm.refundableSplits = getRefundableSplits();
        vm.plootoPaymentEmail = '';

        vm.displayLenderPrompt;

        Principal.identity().then(function(identity) {
            vm.identity = identity;
            User.getIntegrationId({ id: identity.id }).$promise.then(function (value) {
                Promise.resolve(value).then(function (resolved) {
                    vm.isIntegrationOrder = resolved.data;

                    if (resolved.data > 0) {
                        LenderIntegrationBlacklist.isBlackListedByName({
                            integrationID: resolved.data,
                            lenderName: vm.appraisalOrder.lender ? vm.appraisalOrder.lender.lenderName : null
                        }).$promise.then(function (value) {
                            Promise.resolve(value).then(function (resolved) {
                                vm.displayLenderPrompt = resolved.data;
                            });
                        });
                    }
                });
            });
        });

        // Returns true if the only active form is thirdparty
        function isThirdParty() {
            var onlyThirdParty = false;
            for (var formIndex in vm.activeReport.forms) {
                if (vm.activeReport.forms[formIndex].formType === "THIRD_PARTY" && vm.activeReport.forms[formIndex].active === true) {
                    onlyThirdParty = true;
                } else {
                    onlyThirdParty = false;
                }
            }
            return onlyThirdParty;
        }


        $scope.$watch('vm.displayLenderPrompt', function (displayLenderPrompt) {
            if (displayLenderPrompt === "true") {
                //display modal
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('Thank you for choosing Value Connect. Please be advised, due to the lender requirements Value Connect is unable to assist ')
                        .ok('Okay')
                ).then(function () {
                    $state.go('home');
                });
            }
        });

        // Initialize appraisal notes for the order
        vm.AppraisalNotes = [], vm.vcNotes = [];
        if (vm.isAppraiser || vm.isVC) {
            AppraisalNote.getNotesForAppraisal({ id: vm.appraisalOrder.id }, function (data) {
                vm.AppraisalNotes = data;
            });
        }
        if (vm.isVC) {
            VCNote.getVCNotesForAppraisalOrder({ id: vm.appraisalOrder.id }, function (data) {
                vm.vcNotes = data;
            });
        }

        if (vm.isVC && vm.appraisalOrder.lender && vm.appraisalOrder.lender.id && hasAnyState('REPORT_COMPLETE', 'REPORT_ACCEPTED')) {
            AppraisalOrder.getAppraisalReportAccessKeyURL({ id: vm.appraisalOrder.id }).$promise.then(function (data) {
                vm.appraisalReportAccessKeyURL = data.url;
            });
        }

        // Appraisal order editable. Gates the "Adjust Order" button, and nothing else on this page.
        // The AVM carve-out keeps Adjust Order available while the order is still unpaid.
        vm.orderEditable = AppraisalState.inAnyState(vm.appraisalOrder, AppraisalState.orderEditable)
            && avmActionsStillOpen();

        // Reload each quote with additional details
        // TODO: Return this data in the first request
        var quoteRequests = vm.appraisalOrder.appraisalReports.map(function (report) {
            if (!report.quote) return $q.when(report.quote);

            else return Quote.get({ id: report.quote.id }, function (quote) {
                // Identify the active quote
                if (vm.appraisalOrder.appraisalReports.length === 1 ||
                    report.id === vm.appraisalOrder.activeReport.id) {
                    vm.quote = quote;
                }

                report.quote = quote;
            });
        });

        // invoices
        vm.invoices = [];
        vm.getInvoicePdf = getInvoicePdf;
        if (vm.isVC || vm.isAdmin) {
            Invoice.getByFilter({ appraisalOrderId: vm.appraisalOrder.id }, function (data) {
                vm.invoices = data;
            });
        }

        vm.hasPlootoEntry = false;
        if (vm.isAdmin) {
            $http.get('api/accounting/money-service-early-payments/order/' + vm.appraisalOrder.id + '/exists')
                .then(function(res) { vm.hasPlootoEntry = res.data === true; });
        }

        if (vm.isVC) {
            AppraisalOrder.getDetailed({ id: vm.appraisalOrder.id }).$promise.then(function (detailedOrder) {
                vm.plootoPaymentEmail = detailedOrder && detailedOrder.appraisalFirm && detailedOrder.appraisalFirm.paymentEmail
                    ? detailedOrder.appraisalFirm.paymentEmail
                    : '';
            }).catch(function () {
                vm.plootoPaymentEmail = '';
            });
        }

        function getInvoicePdf(id) {
            return InvoiceUtils.getInvoicePdf(id);
        }

        $q.all(quoteRequests).then(function () { vm.entitiesLoaded = true; });

        // Get the appraisal order by id from the quote appraisal order id.
        var appraisalOrderId = vm.appraisalOrder.id;

        function refreshReportAvailability() {
            vm.reportAvailability = buildReportAvailability();
        }

        if (vm.appraisalOrder.$promise) {
            vm.appraisalOrder.$promise.then(function () {
                vm.appraisalOrder.appraisalOrderContacts = AppraisalOrderContact.getcontactbyappraisalorderid({ id: vm.appraisalOrder.id });
                refreshReportAvailability();
            });
        } else {
            refreshReportAvailability();
        }

        // Define methods exposed to view
        vm.requestQuote = requestQuote;

        vm.hasMadeAnyPayment = hasMadeAnyPayment;
        vm.hasPendingClientPayment = hasPendingClientPayment;
        vm.acceptQuote = acceptQuote;
        vm.regenerateReport = regenerateReport;
        vm.isReportBuilderBacked = isReportBuilderBacked;
        vm.isReportBuilderEligible = isReportBuilderEligible;
        vm.isReportBuilderSeedable = isReportBuilderSeedable;
        vm.canOpenValique = canOpenValique;
        vm.canViewUploadedReport = canViewUploadedReport;
        vm.openReportBuilder = openReportBuilder;
        vm.openingReportBuilder = false;
        vm.setupSplit = setupSplit;
        vm.canSetupSplit = canSetupSplit;
        vm.resendPaymentRequest = resendPaymentRequest;

        vm.triggerPaymentDialog = triggerPaymentDialog;
        vm.viewPayment = viewPayment;
        vm.initiateRefund = initiateRefund;
        vm.isPendingChangeRequest = isPendingChangeRequest;
        vm.isNoAppraiserOptions = isNoAppraiserOptions;
        vm.updateAppraiserAppraisalId = updateAppraiserAppraisalId;
        vm.cancelOrder = cancelOrder;
        vm.appraiserAction = appraiserAction;
        vm.ccrAction = ccrAction;
        vm.downloadFile = downloadFile;
        vm.createAdditionalInspectionReport = createAdditionalInspectionReport;
        vm.generateICal = generateICal;
        vm.inState = inState;
        vm.hasAnyState = hasAnyState;
        vm.openAppraisalOrderChangeRequestDialog = openAppraisalOrderChangeRequestDialog;
        vm.getLogEvent = getLogEvent;
        vm.applyCoupon = applyCoupon;
        vm.removeCoupon = removeCoupon;
        vm.hasOrderOption = hasOrderOption;
        vm.printScreen = printScreen;
        vm.printBrokerInvoice = printBrokerInvoice;
        vm.brokerBundledPrice = brokerBundledPrice;
        vm.brokerPrint = false;
        vm.allowChangeRequests = hasAnyState('PENDING_APPRAISER_ACCEPTANCE', 'PENDING_SCHEDULE_VISIT', 'PENDING_VISIT', 'PENDING_SUBMISSION', 'RESUBMISSION_REQUIRED')
            && (checkAssigned() || Principal.hasAnyAuthority([/^ROLE_APPRAISAL.*/]) || vm.isVC);
        vm.changeOrderState = changeOrderState;
        vm.getNumUnitsRequiringMarketRent = getNumUnitsRequiringMarketRent;
        vm.getWhichUnitsRequireMarketRent = getWhichUnitsRequireMarketRent;
        vm.hasPlaceholderLender = hasPlaceholderLender;
        vm.finalizeLender = finalizeLender;
        vm.markRequiresEarlyPayment = markRequiresEarlyPayment;
        vm.isAppraiserUser = !!(account && account.authorities &&
            account.authorities.some(function(authority) {
                return /^ROLE_(APPRAISER|APPRAISAL).*/.test(authority);
            }));

        vm.estimatedLTV = calculateEstimatedLTV(vm.appraisalOrder);
        vm.displayEstimatedLTV = getDisplayedEstimatedLTV(vm.appraisalOrder, vm.isAppraiserUser);

        Principal.matchAnyAuthority(/^ROLE_(ADMIN|CUSTOMER_CARE|APPRAISER|APPRAISAL|VC).*/gi).then(function (result) {
            if (result) {
                vm.showDetails = true;

                AppraisalOrderChangeRequest.getForAppraisalOrderId({ id: vm.appraisalOrder.id }, function (data) {
                    vm.changeRequests = data;
                });
            }
        });

        /**
         * Show a confirmation dialog then send a request to request a quote for the order. State will
         * be reloaded on success.
         * @param  {Event} ev Optional. The javascript click event that opened the dialog
         * @return {Promise}  A promise that will be resolved with the result of the request, or
         *                    cancelled with any failure that occurs
         */
        function requestQuote(ev) {
            return AppraisalOrderModal.requestQuote(vm.appraisalOrder, ev).then(function (result) {
                // Reload state
                return $state.reload().then(function () {
                    // Show success message
                    AlertService.success('valueconnectApp.appraisalOrder.quoteRequested', { id: vm.appraisalOrder.id });
                    return result;
                });
            });
        }

        function printScreen() {
            window.print();
        }

        /**
         * Print the "broker version" of the order summary: the exact same print output as printScreen(),
         * but with the quote's line items collapsed into a single bundled "Appraisal Report" line (coupons
         * kept separate) so brokers don't see the fee breakdown. Toggles vm.brokerPrint around window.print()
         * so the collapsed view only appears in the printout, then reverts.
         */
        function printBrokerInvoice() {
            vm.brokerPrint = true;
            // Defer to the next digest so the DOM reflects the collapsed view before printing, then revert.
            $timeout(function () {
                window.print();
                vm.brokerPrint = false;
            });
        }

        /**
         * Sum the retail price of all non-coupon line items on a quote (the bundled "Appraisal Report"
         * amount shown on the broker version of the print summary).
         */
        function brokerBundledPrice(quote) {
            if (!quote || !quote.lineItems) {
                return 0;
            }
            return quote.lineItems
                .filter(function (lineItem) {
                    return lineItem.regionalProductProductType !== 'COUPON' && lineItem.price != 0;
                })
                .reduce(function (sum, lineItem) {
                    return sum + (lineItem.price || 0);
                }, 0);
        }

        function calculateEstimatedLTV(appraisalOrder) {
            if (!appraisalOrder || appraisalOrder.lendersEstimatedPropertyValue == null ||
                appraisalOrder.lendersEstimatedPropertyValue <= 0) {
                return null;
            }

            var totalLoanAmount = 0;
            var hasLoanAmount = false;
            if (appraisalOrder.loanAmount != null) {
                totalLoanAmount += appraisalOrder.loanAmount;
                hasLoanAmount = true;
            }
            if (appraisalOrder.firstMortgageLoanAmount != null) {
                totalLoanAmount += appraisalOrder.firstMortgageLoanAmount;
                hasLoanAmount = true;
            }
            if (appraisalOrder.secondMortgageLoanAmount != null) {
                totalLoanAmount += appraisalOrder.secondMortgageLoanAmount;
                hasLoanAmount = true;
            }

            if (!hasLoanAmount) {
                return null;
            }

            return totalLoanAmount / appraisalOrder.lendersEstimatedPropertyValue;
        }

        function getDisplayedEstimatedLTV(appraisalOrder, applyAppraiserFloor) {
            var estimatedLTV = calculateEstimatedLTV(appraisalOrder);
            if (estimatedLTV == null) {
                return null;
            }

            return applyAppraiserFloor ? Math.max(estimatedLTV, 0.8) : estimatedLTV;
        }

        function hasMadeAnyPayment() {
            if (!vm.quote) return false;
            return vm.quote.quoteSplits && vm.quote.quoteSplits.some(function (split) { return split.paymentSplits.length > 0; });
        }

        function hasPendingClientPayment() {
            if (!vm.quote) return false;
            return vm.quote.quoteSplits && vm.quote.quoteSplits.some(function(split) {
                return split.role === 'CLIENT' && split.paymentSplits.length === 0 && split.splitAmount > 0;
            });
        }



        function resendPaymentRequest() {
            QuoteSplitModalService.openResendPaymentRequestDialog(vm.quote, vm.appraisalOrder.clientContact).result.then(
                function(data, headers) { $state.reload(); },
                function(data, headers) {
                    if(data === 'cancel' || data === 'backdrop click') return;
                    AlertService.error("An error occurred while resending the payment request. Please contact Value Connect support.");
                });
        }

        function acceptQuote() {
            QuoteSplit.update({ 'quoteId': vm.quote.id, 'originatorAmount': vm.quote.total },
                function (data, headers) { $state.reload(); },
                function (data, headers) {
                    if (data === 'cancel' || data === 'backdrop click') return;
                    AlertService.error("An error occurred while accepting the quote. Please contact Value Connect support.");
                });
        }

        /**
         * True once this order has been seeded into the v2 report builder. Seeding also switches our own
         * report to the third-party form so it can receive the finished PDF, so this flag is what stops
         * the appraiser's Build/Update row from turning into "Upload PDF Report" for a report they are
         * still building.
         */
        function isReportBuilderBacked() {
            return !!(vm.appraisalOrder.activeReport && vm.appraisalOrder.activeReport.valiqueReportId);
        }

        /**
         * Whether this order's product is one Valique builds — today, the full report only.
         *
         * Read off the payload rather than derived from the type here, so the rule lives on AppraisalType
         * where the v2 action rail reads it too, and a function rather than a snapshot because the order
         * is re-fetched after several of the actions on this page.
         */
        function isReportBuilderEligible() {
            return vm.appraisalOrder.reportBuilderEligible === true;
        }

        /**
         * Whether this order's report can be created in Valique right now. Emitted by the server so this
         * page and ReportBuilderSeedService cannot disagree — the check covers the order's state, whether
         * this is still the active report, and whether the appraiser already uploaded a PDF, which the
         * page's own 'editable' state list knows nothing about.
         *
         * Only about *creating*. An order already backed by Valique opens whatever its state, which is
         * why the row's condition asks isReportBuilderBacked() first.
         */
        function isReportBuilderSeedable() {
            return vm.appraisalOrder.reportBuilderSeedable === true;
        }

        /**
         * The two halves of VC staff's report link, kept apart because they need different conditions.
         *
         * Valique: openable once the order is backed by it, whatever the order's state — that is a
         * navigation to a report that already exists, and staff still need to reach a delivered one —
         * or, before seeding, only while the order can still receive one.
         */
        function canOpenValique() {
            return isReportBuilderEligible()
                && (isReportBuilderBacked() || isReportBuilderSeedable());
        }

        /**
         * A read-only look at the PDF an appraiser uploaded, for the products Valique does not build.
         *
         * Both conditions are load-bearing. Without 'editable' the legacy builder's onEnter alerts
         * "not in an editable state" and redirects home, so the link would break on exactly the closed
         * orders someone wants to inspect (Review Report is the route there).
         *
         * hasThirdPartyReportUploaded, not isThirdParty: every report holds the third-party form from
         * acceptance now, so "converted" would be true from the moment the appraiser accepted and this
         * row would promise an uploaded report for days before one existed. The Report Availability line
         * on this same page keys off the same flag, so the two agree about what "uploaded" means.
         *
         * Deliberately NOT gated on the product being ineligible for the report builder. A report
         * Valique built is uploaded here as a PDF and still submitted from the third-party page, so
         * staff need the same route to it that they have always had; requiring ineligibility would take
         * that away for exactly the five products the report builder now handles. On those orders this
         * row sits alongside View Report Builder rather than replacing it.
         */
        function canViewUploadedReport() {
            return vm.appraisalOrder.hasThirdPartyReportUploaded === true
                && inState('editable');
        }

        /**
         * Opens this order's report in the v2 report builder, creating it there on the first click. The
         * server returns the URL, so nothing here needs to know the report builder's routing or the path
         * prefix it sits behind when deployed.
         */
        function openReportBuilder(event) {
            if (event) {
                event.preventDefault();
            }
            if (vm.openingReportBuilder) {
                return;
            }
            // Building in the v2 report builder switches this report to the third-party form, which
            // deactivates the forms filled in here — the same loss the Upload PDF Report flow warns
            // about. Confirm first when there is work to lose. Once seeded the forms are already
            // inactive, so started reads false and this cannot nag on later visits.
            if (vm.activeReport && vm.activeReport.started) {
                // Deliberately the same words as the third-party uploader's warning — the operation loses
                // the same work, so it should read the same. (Strictly the forms are deactivated rather
                // than deleted; the firmer wording is the chosen copy. See OpenReportBuilderWarningDialog.)
                var confirm = $mdDialog.confirm()
                    .title('Valique Report Builder')
                    .textContent('WARNING: The existing forms and data you have entered in the report '
                        + 'builder will be deleted and replaced. This operation cannot be undone. Click OK '
                        + 'to continue to Valique, or Cancel to go back.')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function () {
                    requestReportBuilderLink();
                });
                return;
            }
            requestReportBuilderLink();
        }

        function requestReportBuilderLink() {
            vm.openingReportBuilder = true;
            AppraisalReport
                .reportBuilderLink(
                    {'id': vm.appraisalOrder.activeReport.id},
                    {},
                    function(result) {
                        vm.openingReportBuilder = false;
                        if (result && result.url) {
                            $window.location.href = result.url;
                        } else {
                            AlertService.error("Valique is not configured for this environment. Please contact Value Connect support.");
                        }
                    },
                    function(response) {
                        vm.openingReportBuilder = false;
                        // A refusal (409) arrives with its own sentence, which the global error
                        // interceptor has already shown — saying "try again" underneath it would be
                        // both duplicated and wrong, since a refusal never becomes a success.
                        var serverMessage = response && response.headers
                            && response.headers('X-valueconnectApp-error');
                        if (!serverMessage) {
                            AlertService.error("Could not open Valique. Please try again, or contact Value Connect support.");
                        }
                    }
                );
        }

        function regenerateReport() {
            AppraisalReport
                .regenerateReport(
                    {'id': vm.appraisalOrder.activeReport.id},
                    {},
                    function() {
                        AlertService.success("Report created");
                    },
                    function(error) {
                        AlertService.error(error.data.description);
                    }
                );
        }

        /**
         * Whether an AVM order is still open to the two actions it legitimately has.
         *
         * AVM orders are excluded from most actions on this page because they have no appraiser and no
         * visit. Adjusting the order and paying for it are the exceptions: both are the same act they
         * would be on any other product, and both only make sense before the order is paid — so the
         * exclusion is lifted while it is still drafted or awaiting payment, and applies again after.
         * Past that point an AVM has neither a payment step left to revisit nor anything an adjustment
         * could change: it has already been valued.
         *
         * Non-AVM orders are never restricted by this.
         */
        function avmActionsStillOpen() {
            return !vm.isAnyAvm || hasAnyState('ORDER_DRAFTED', 'PENDING_PAYMENT');
        }

        /** Whether the payment options dialog can be opened for this order. */
        function canSetupSplit() {
            return avmActionsStillOpen();
        }

        /**
         * The AVM answers as flat label/value pairs for the property information section.
         *
         * Only ENRICHED collects property attributes; the other two profiles send little more than the
         * address, so they get no section rather than an almost-empty one. Null answers are dropped — every
         * ENRICHED field except condition is optional, and a row of blanks is worse than no row.
         *
         * Enum values are humanised here (WELL_MAINTAINED -> "Well Maintained") rather than translated:
         * these seven AVM enums have no i18n entries, and inventing ~40 of them to display a handful of
         * read-only values on one admin section is not worth the upkeep. Labels are translated normally.
         */
        function buildAvmPropertyDetails(avmDetails) {
            if (!avmDetails || avmDetails.valuationProfile !== 'ENRICHED') {
                return [];
            }
            var fields = [
                { key: 'propertyType',      value: humanise(avmDetails.propertyType) },
                { key: 'isCondo',           value: bool(avmDetails.isCondo) },
                { key: 'aptNum',            value: avmDetails.aptNum },
                { key: 'condition',         value: humanise(avmDetails.condition) },
                { key: 'numBedrooms',       value: avmDetails.numBedrooms },
                { key: 'numDens',           value: avmDetails.numDens },
                { key: 'numBathrooms',      value: avmDetails.numBathrooms },
                { key: 'numKitchens',       value: avmDetails.numKitchens },
                { key: 'numParkingSpaces',  value: avmDetails.numParkingSpaces },
                { key: 'buildingStyle',     value: humanise(avmDetails.buildingStyle) },
                { key: 'basementType',      value: humanise(avmDetails.basementType) },
                { key: 'garageType',        value: humanise(avmDetails.garageType) },
                { key: 'airConditioning',   value: humanise(avmDetails.airConditioning) },
                { key: 'pool',              value: humanise(avmDetails.pool) },
                { key: 'sqft',              value: avmDetails.sqft },
                { key: 'roomsArea',         value: avmDetails.roomsArea },
                { key: 'lotArea',           value: avmDetails.lotArea },
                { key: 'ageYears',          value: avmDetails.ageYears }
            ];
            return fields.filter(function (f) {
                return f.value !== null && f.value !== undefined && f.value !== '';
            });
        }

        /** UPPER_SNAKE enum token to Title Case, e.g. WELL_MAINTAINED -> "Well Maintained". */
        function humanise(token) {
            if (!token) {
                return null;
            }
            return String(token).toLowerCase().split('_').map(function (word) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(' ');
        }

        /** Kept explicit so a false answer still renders, instead of being filtered out as empty. */
        function bool(value) {
            if (value === null || value === undefined) {
                return null;
            }
            return value ? 'Yes' : 'No';
        }

        function setupSplit() {
            QuoteSplitModalService.openCreateDialog(vm.quote, vm.appraisalOrder.clientContact, { invoicingEnabled: account.invoicingEnabled || false }).result.then(
                function (data, headers) { $state.reload(); },
                function (data, headers) {
                    if (data === 'cancel' || data === 'backdrop click') return;
                    AlertService.error("An error occurred while accepting the quote. Please contact Value Connect support.");
                });
        }

        function triggerPaymentDialog(split) {
            AppraisalOrderModal.openPaymentDialog(split);
        }

        function initiateRefund(split) {
            AppraisalOrderModal.openRefundDialog(split, vm.appraisalOrder);
        }

        function getRefundableSplits() {
            var splits = [];
            var adjustmentCount = 0;

            vm.appraisalOrder.appraisalReports.forEach(function(report) {
                if (report.quote && report.quote.quoteSplits) {
                    report.quote.quoteSplits.forEach(function(split) {
                        if (split.role !== 'VALUE_CONNECT') {
                            if (split.invoiceType === 'INITIAL') {
                                split._paymentLabel = 'Initial Payment';
                            } else {
                                adjustmentCount++;
                                split._paymentLabel = 'Adjustment';
                            }
                            splits.push(split);
                        }
                    });
                }
            });

            if (adjustmentCount > 1) {
                var adjIndex = 0;
                splits.forEach(function(split) {
                    if (split._paymentLabel === 'Adjustment') {
                        adjIndex++;
                        split._paymentLabel = 'Adjustment ' + adjIndex;
                    }
                });
            }

            return splits;
        }

        function viewPayment(s) {
            if (s.role !== "VALUE_CONNECT" && s.splitAmount > 0 && s.paymentSplits.length > 0) {
                $state.go("payment-detail", { id: s.paymentSplits[0].paymentId });
            }
        }

        function isPendingChangeRequest(ev) {
            return /^ACCEPTANCE_PENDING_.*/.test(vm.appraisalOrder.state);
        }

        function isNoAppraiserOptions(ev) {
            return /^(ORDER_DRAFTED|PENDING_PAYMENT|PAYMENT_COMPLETE|PENDING_ASSIGNMENT|ADDITIONAL_PAYMENT_REQUIRED|ORDER_CANCELLED)/.test(vm.appraisalOrder.state);
        }

        function updateAppraiserAppraisalId() {
            AppraisalOrder.setInternalId(vm.appraisalOrder, function (data) {

            });
        }

        function cancelOrder(ev) {
            AppraisalOrderModal.openCancelAppraisalOrderDialog(vm.appraisalOrder).then(function (data) {

            });
        }

        function checkAssigned() {
            return account.appraiserUser && vm.appraisalOrder.assignedAppraiserId === account.appraiserUser.id;
        }

        function openAppraisalOrderChangeRequestDialog(changeRequest) {
            Principal.matchAnyAuthority(/^ROLE_(CUSTOMER_CARE|VC|ADMIN).*/).then(function (resp) {
                if (resp) {
                    AppraisalOrderModal.openCcrAppraisalOrderChangeRequestDialog(vm.appraisalOrder, changeRequest);
                } else {
                    AppraisalOrderModal.openAppraisalOrderChangeRequestDialog(null, vm.appraisalOrder, changeRequest,
                        vm.hasAnyState('PAYMENT_COMPLETE', 'PENDING_ASSIGNMENT', 'PENDING_APPRAISER_ACCEPTANCE'));
                }
            });
        }

        function appraiserAction(actionType, ev) {
            // Open a dialog then handle the result
            var modal = openDialog(actionType);
            var promise = modal && modal.result ? modal.result : modal;  // uibModal and mdModal return promises differently
            promise.then(handleSuccess, handleClose);

            function openDialog(actionType) {
                switch (actionType) {
                    case 'ACCEPT':
                        return AppraisalOrderModal.openAcceptDialog(vm.appraisalOrder);
                    case 'DECLINE':
                        return AppraisalOrderModal.openDeclinedDialog(vm.appraisalOrder);
                    case 'CLARIFY':
                    case 'FEE_CHANGE':
                    case 'DUE_DATE_CHANGE':
                        return AppraisalOrderModal.openAppraisalOrderChangeRequestDialog(actionType, vm.appraisalOrder);
                    case 'SCHEDULE_VISIT':
                        return AppraisalOrderModal.scheduleVisit(vm.appraisalOrder);
                    case 'COMPLETE_VISIT':
                        return AppraisalOrderModal.completeVisit(vm.appraisalOrder, ev);
                    case 'ASSIGN_COSIGNER':
                        return AppraisalOrderModal.assignCosigner(vm.appraisalOrder);
                    case 'THIRD_PARTY_UPLOAD':
                        return AppraisalOrderModal.thirdPartyUpload(vm.activeReport, ev);
                }
            }

            function handleSuccess(result) {
                if (actionType === 'THIRD_PARTY_UPLOAD') {
                    $state.go('form.builder', { id: vm.activeReport.id });
                } else if (actionType === 'DECLINE') {
                    $state.go('home');
                } else {
                    $state.reload();
                }
            }

            function handleClose(error) {
                if (error !== undefined) {
                    AlertService.error("Oops! An error has occurred. Please contact info@valueconnect.ca if the issue persists.")
                }
            }
        }

        function ccrAction(actionType, ev) {
            if (actionType === 'CLONE_ORDER') {
                // Confirm, then clone directly and navigate to the new order's summary page. We do NOT route
                // through AppraisalOrderModal here because its shared dialog helper reloads the current state,
                // which would strand the user on the source order instead of the freshly created clone.
                var confirm = $mdDialog.confirm()
                    .title('Clone Order')
                    .textContent('Create a new drafted order copied from this one?')
                    .targetEvent(ev)
                    .ok('Clone')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function () {
                    AppraisalOrder.clone({id: vm.appraisalOrder.id}, {}, function (result) {
                        AlertService.success("Order cloned successfully");
                        $state.go('appraisal-order-detail', {id: result.id});
                    }, function (error) {
                        if (error && error.data && error.data.error) AlertService.error(error.data.error);
                    });
                });
            } else if (actionType === 'REDIRECT_ORDER') {

                AppraisalOrderModal.redirectOrder(vm.appraisalOrder).then(function (result) {
                    vm.appraisalOrder = AppraisalOrder.get({id: result.id});
                    AlertService.success("Lender updated successfully");
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });
            } else if (actionType === 'RESTORE_CANCELLED_ORDER') {

                AppraisalOrderModal.restoreCancelledOrder(vm.appraisalOrder).then(function (result) {
                    if (result !== undefined) {
                        vm.appraisalOrder = AppraisalOrder.get({id: result.id});
                    }
                    AlertService.success("Appraisal order restored successfully");
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });

            } else if (actionType === 'POSTPONE_CANCELLATION') {

                // No dialog: fire the request directly and toast the result. Reloads the order so the
                // button hides once the counter is reset (order leaves the 30-35 day window).
                AppraisalOrder.postponeCancellation({id: vm.appraisalOrder.id}, {}, function (result) {
                    vm.appraisalOrder = AppraisalOrder.get({id: result.id});
                    AlertService.success("Cancellation postponed - this order won't be auto-cancelled for another 35 days.");
                }, function (error) {
                    AlertService.error(error && error.data && error.data.message ? error.data.message : "Couldn't postpone cancellation. Please try again.");
                });

            } else if (actionType === 'RESEND_REPORT_TO_LENDER') {

                var to = vm.appraisalOrder.lenderUnderwriterContact.appraisalReportSendToEmailAddress;
                var resendConfirm = $mdDialog.confirm()
                    .title('Resend Report to Lender')
                    .textContent('Resend the report email to ' + to + '?')
                    .targetEvent(ev)
                    .ok('Resend')
                    .cancel('Cancel');
                $mdDialog.show(resendConfirm).then(function () {
                    AppraisalOrder.resendReportToLender({id: vm.appraisalOrder.id}, {}, function () {
                        vm.appraisalOrder = AppraisalOrder.get({id: vm.appraisalOrder.id});
                        AlertService.success('Report email sent to ' + to + '.');
                    }, function (error) {
                        // A 400 carries its message in a header that the error interceptor already shows.
                        if (!error.headers('X-valueconnectApp-error')) {
                            AlertService.error("Couldn't resend the report to the lender. Please try again.");
                        }
                    });
                });

            } else if (actionType === 'CHANGE_DUE_DATE') {

                AppraisalOrderModal.changeDueDate(vm.appraisalOrder).then(function (result) {
                    vm.appraisalOrder = AppraisalOrder.get({id: result.id});
                    AlertService.success("Due Date updated successfully");
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });
            } else if (actionType === 'CHANGE_UNDERWRITER') {

                AppraisalOrderModal.changeUnderwriter(vm.appraisalOrder).then(function (result) {
                    vm.appraisalOrder = AppraisalOrder.get({id: result.id});
                    AlertService.success("Underwriter updated successfully");
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });
            } else if (actionType === 'SEND_REPORT_BACK') {

                AppraisalOrderModal.sendReportBack(vm.appraisalOrder.activeReport).then(function (result) {
                    vm.appraisalOrder = AppraisalOrder.get({id: result.appraisal_order_id});
                    AlertService.success("The order has been sent back to the appraiser");
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });
            } else if (actionType === 'ADD_VC_NOTE') {

                AppraisalOrderModal.addVCNote(vm.appraisalOrder).then(function (result) {
                    VCNote.getVCNotesForAppraisalOrder({ id: vm.appraisalOrder.id }, function (data) {
                        vm.vcNotes = data;
                    });
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });
            } else if (actionType === 'QUOTE_REQUESTS') {
                AppraisalOrderModal.quoteRequests(vm.appraisalOrder).then(function () {
                    $state.reload();
                });
            } else {
                AppraisalOrderModal.assignAppraiser(vm.appraisalOrder, actionType).then(function (result) {
                    $state.reload();
                    AlertService.success("valueconnectApp.appraisalOrder.assignAppraiser.success." + actionType, {});
                }, function (result) {
                    if (result && result.error) AlertService.error(result.error);
                });
            }

        }

        function createAdditionalInspectionReport(ev) {
            $mdDialog.show({
                templateUrl: 'app/entities/appraisal-report/appraisal-report-new-dialog.html',
                controller: 'AppraisalReportNewDialogController',
                controllerAs: 'vm',
                fullscreen: false,
                locals: {
                    entity: {
                        id: null,
                        appraisalOrderId: appraisalOrderId
                    }
                }
            }).then(function () {
                // TODO: implement
            });
        }

        function downloadFile(file) {
            File.download({ id: file.id, appraisalOrderId: vm.appraisalOrder.id }, function (response) {
                var fileData = new Blob([response.data], { type: file.contentType });
                FileSaver.saveAs(fileData, file.fileName);
            });
        }

        function generateICal() {
            AppraisalReport.generateICal({ id: vm.appraisalOrder.appraisalReports[0].id }, {}, function (data) {
                var fileData = new Blob([data.data], { type: 'text/calendar' });
                FileSaver.saveAs(fileData, 'appraisal-visit-' + vm.appraisalOrder.id + '.ics');
            }, function (data) {
                alert("Unable to generate iCal");
            });
        }

        function inState(state) {
            return AppraisalState.inState(vm.appraisalOrder, state);
        }

        /**
         * Check if the current appraisal order has any of the specified states.
         * Each states to check should be passed as a seperate string argument.
         *
         * @return {Boolean} True if the appraisal order has any of the provided states, otherwise false
         */
        function hasAnyState() {
            var states = Array.prototype.slice.call(arguments);
            return AppraisalState.inAnyState(vm.appraisalOrder, states);
        }

        /**
         * Retrieve the latest event of the provided type
         * @param  {String} logType The type of event to retrieve
         * @return {Object}         The latest event of the provided type, or null if none exists
         */
        function getLogEvent(logType) {
            if (!vm.appraisalOrder.orderLog) {
                return null;
            }

            return vm.appraisalOrder.orderLog.filter(function (event) {
                return event.auditEventType === logType;
            })[0] || null;
        }

        function applyCoupon(couponCode, quote) {
            Coupon.apply({ couponCode: couponCode, quoteId: quote.id }, function (resp) {

                //Update the necessary parts of the quote so the frontend refreshes
                quote.lineItems = resp.lineItems;
                quote.subTotal = resp.subTotal;
                quote.total = resp.total;

            });
        }

        function removeCoupon(quote) {
            Coupon.removeFromQuote({ quoteId: quote.id }, {}, function (resp) {

                //Update the necessary parts of the quote so the frontend refreshes
                quote.lineItems = resp.lineItems;
                quote.subTotal = resp.subTotal;
                quote.total = resp.total;

            });
        }

        function hasOrderOption(option) {
            return vm.appraisalOrder.options
                && $filter('filter')(vm.appraisalOrder.options, { name: option }, true).length;
        }

        function printLogData(log, key, data) {
            if (log.auditEventType === "EMAIL" && key === "content") {
                return $sce.trustAsHtml(data);
            } else {
                return data;
            }

        }

        function showLogDetails(log) {
            vm.logToggle[log.id] = !(vm.logToggle[log.id] | false);
        }

        var unsubscribe = $rootScope.$on('valueconnectApp:appraisalOrderUpdate', function (event, result) {
            vm.appraisalOrder = result;
        });
        $scope.$on('$destroy', function () {
            unsubscribe();
        });

        function changeOrderState() {
            return AppraisalOrderModal.changeOrderState(vm.appraisalOrder);
        }

        function getNumUnitsRequiringMarketRent() {
            const marketRentsOption = vm.appraisalOrder.options.find(function (option) { return option.name === 'MARKET_RENTS' } )
            if (marketRentsOption != null && marketRentsOption.value != null) {
                const marketRentsOptionValue = JSON.parse(marketRentsOption.value)
                if (marketRentsOptionValue.numUnitsRequiringMarketRent != null) {
                    return marketRentsOptionValue.numUnitsRequiringMarketRent
                } else {
                    return 1
                }
            }
        }

        function getWhichUnitsRequireMarketRent() {
            const marketRentsOption = vm.appraisalOrder.options.find(function (option) { return option.name === 'MARKET_RENTS' } )
            if (marketRentsOption != null && marketRentsOption.value != null) {
                const marketRentsOptionValue = JSON.parse(marketRentsOption.value)
                if (marketRentsOptionValue.unitsRequiringMarketRentDescription != null) {
                    return marketRentsOptionValue.unitsRequiringMarketRentDescription
                }
            }
        }

        function getPlaceholderLenderOptions() {
            const placeholderLenderOption = vm.appraisalOrder.options.find(function (option) { return option.name === 'PLACEHOLDER_LENDER' })
            if (placeholderLenderOption != null && placeholderLenderOption.value != null) {
                const placeholderLenderOptionValue = JSON.parse(placeholderLenderOption.value)
                if (placeholderLenderOptionValue.potentialLenders != null) {
                    return placeholderLenderOptionValue.potentialLenders.map(function (potentialLender) {
                        return { id: potentialLender.id, name: potentialLender.lenderName }
                    })
                }
            }
        }

        function navigateToEditOrder(appraisalId) {
            var baseUrl = v2OrderBaseUrl || ($window.location.protocol + "//" + $window.location.host);
            $window.location.href = baseUrl + "/v2/appraisal-order/" + appraisalId + '/edit';
        }

        function copyOrderDetails() {
            let orderDetails = 'Order Details\n\n'

            // Type
            orderDetails += `Type: ${$filter('translate')('valueconnectApp.EnumAppraisalType.' + vm.appraisalOrder.appraisalTypeOptions)}\n`;

            // Purpose
            orderDetails += `Purpose: ${$filter('translate')('valueconnectApp.EnumAppraisalPurpose.' + vm.appraisalOrder.appraisalType)}\n`;
            if (vm.appraisalOrder.financingPurpose) {
                orderDetails += `Financing: ${$filter('translate')('valueconnectApp.FinancingPurpose.' + vm.appraisalOrder.financingPurpose)}\n`;
            }
            if (vm.purchaseClosingDate) {
                orderDetails += `Purchase Closing Date: ${vm.purchaseClosingDate}\n`;
            }

            // Address
            orderDetails += `Address: ${vm.appraisalOrder.address.address1} `
            if (vm.appraisalOrder.address.address2) {
                orderDetails += `${vm.appraisalOrder.address.address2} `
            }
            orderDetails += `${vm.appraisalOrder.address.cityName}, ${vm.appraisalOrder.address.provinceName} ${vm.appraisalOrder.address.postCode}\n`;

            // Lender
            if (vm.appraisalOrder.lender) {
                orderDetails += `Lender: ${vm.appraisalOrder.lender.lenderName}\n`;
            } else if (vm.hasOrderOption('PLACEHOLDER_LENDER')) {
                orderDetails += `Potential Lender(s): ${vm.placeholderLenderOptions.map(lender => lender.name).join(', ')}\n`;
            }

            // Mortgage Amounts
            if (vm.appraisalOrder.firstMortgageLoanAmount) {
                orderDetails += `First Mortgage Amount: $${$filter('number')(vm.appraisalOrder.firstMortgageLoanAmount, 2)}\n`;
            }
            if (vm.appraisalOrder.secondMortgageLoanAmount) {
                orderDetails += `Second Mortgage Amount: $${$filter('number')(vm.appraisalOrder.secondMortgageLoanAmount, 2)}\n`;
            }

            // Estimated LTV
            if (vm.displayEstimatedLTV) {
                orderDetails += `LTV: ${$filter('number')(vm.displayEstimatedLTV * 100, 2)}%\n`;
            }

            // Estimated Market Value
            if (vm.appraisalOrder.lendersEstimatedPropertyValue) {
                orderDetails += `EMV: $${$filter('number')(vm.appraisalOrder.lendersEstimatedPropertyValue, 2)}\n`;
            }

            // Number of units
            if (vm.appraisalOrder.numUnits) {
                orderDetails += `Number of Units: ${vm.appraisalOrder.numUnits}\n`;
            }

            // Market Rents
            if (vm.hasOrderOption('MARKET_RENTS')) {
                orderDetails += `**MARKET RENTS REQUIRED**: ${vm.getNumUnitsRequiringMarketRent()} unit(s) require market rent.`;
                if (vm.getWhichUnitsRequireMarketRent()) {
                    orderDetails += ` (${vm.getWhichUnitsRequireMarketRent()})`;
                }
                orderDetails += '\n';
            }

            // Lot Size
            if (vm.appraisalOrder.housePlusLotSize) {
                orderDetails += `Acres: ${vm.appraisalOrder.housePlusLotSize} ${$filter('translate')('valueconnectApp.enum.AreaUnit.' + vm.appraisalOrder.lotSizeUnits)}\n`;
            }

            // Outbuildings to count
            if (vm.hasOrderOption('OUTBUILDINGS_TO_COUNT')) {
                orderDetails += `Outbuildings: ${$filter('translate')('valueconnectApp.enum.BooleanOrOther.YES')}`
            }

            navigator.clipboard.writeText(orderDetails).then(function() {
                AlertService.success("Order details copied to clipboard.");
            }).catch(function() {
                AlertService.error("Failed to copy order details.");
            })
        }

        function copyPlootoDetails() {
            if (!vm.isVC) {
                return;
            }

            const row = [
                vm.appraisalOrder && vm.appraisalOrder.id != null ? vm.appraisalOrder.id : '',
                getAppraisalFirmNameForPlooto(),
                vm.plootoPaymentEmail || '',
                getBusinessDateFromToday(3),
                getAppraiserCostTaxInclusiveForPlooto()
            ].join('\t');

            navigator.clipboard.writeText(row).then(function() {
                AlertService.success("Plooto details copied to clipboard.");
            }).catch(function() {
                AlertService.error("Failed to copy Plooto details.");
            });
        }

        function getAppraisalFirmNameForPlooto() {
            if (vm.appraisalOrder.assignedAppraisalFirmName) {
                return vm.appraisalOrder.assignedAppraisalFirmName;
            }
            if (vm.appraisalOrder.assignedAppraiser && vm.appraisalOrder.assignedAppraiser.appraisalFirmName) {
                return vm.appraisalOrder.assignedAppraiser.appraisalFirmName;
            }
            if (vm.appraisalOrder.appraisalFirmSelection && vm.appraisalOrder.appraisalFirmSelection.appraisalFirmName) {
                return vm.appraisalOrder.appraisalFirmSelection.appraisalFirmName;
            }
            return vm.appraisalOrder.appraisalFirmName || '';
        }

        function getBusinessDateFromToday(businessDaysToAdd) {
            const date = new Date();
            let businessDaysAdded = 0;

            while (businessDaysAdded < businessDaysToAdd) {
                date.setDate(date.getDate() + 1);
                const dayOfWeek = date.getDay();
                if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                    businessDaysAdded++;
                }
            }

            return `${date.getFullYear()}-${padTwoDigits(date.getMonth() + 1)}-${padTwoDigits(date.getDate())}`;
        }

        function padTwoDigits(number) {
            return number < 10 ? `0${number}` : `${number}`;
        }

        function getAppraiserCostTaxInclusiveForPlooto() {
            const quote = vm.quote || (vm.activeReport ? vm.activeReport.quote : null);
            if (!quote) {
                return '';
            }

            const feePaidTotal = getTaxInclusiveTotal(quote.feePaid, quote.feePaidTax);
            if (feePaidTotal != null) {
                return $filter('number')(feePaidTotal, 2);
            }

            const feeProposedTotal = getTaxInclusiveTotal(quote.feeProposed, quote.feeProposedTax);
            if (feeProposedTotal != null) {
                return $filter('number')(feeProposedTotal, 2);
            }

            return '';
        }

        function getTaxInclusiveTotal(baseValue, taxValue) {
            const parsedBaseValue = toNumberOrNull(baseValue);
            if (parsedBaseValue == null) {
                return null;
            }

            const parsedTaxValue = toNumberOrNull(taxValue);
            return parsedBaseValue + (parsedTaxValue == null ? 0 : parsedTaxValue);
        }

        function toNumberOrNull(value) {
            if (value == null || value === '') {
                return null;
            }

            const parsedValue = Number(value);
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function copyClientContactDetails() {
            let clientContactDetails = 'Client Contact Details\n\n'

            // Client Contact
            if (vm.appraisalOrder.clientContact) {
                if (vm.appraisalOrder.clientContact.firstName && vm.appraisalOrder.clientContact.lastName) {
                    clientContactDetails += `Name: ${vm.appraisalOrder.clientContact.firstName} ${vm.appraisalOrder.clientContact.lastName}\n`;
                }

                if (vm.appraisalOrder.clientContact.emailAddress) {
                    clientContactDetails += `Email: ${vm.appraisalOrder.clientContact.emailAddress}\n`;
                }

                if (vm.appraisalOrder.clientContact.phoneNumber) {
                    clientContactDetails += `Phone: ${vm.appraisalOrder.clientContact.phoneNumber}\n`;
                }
            }

            navigator.clipboard.writeText(clientContactDetails).then(function() {
                AlertService.success("Client contact details copied to clipboard.");
            }).catch(function() {
                AlertService.error("Failed to copy client contact details.");
            })
        }

        function copyPropertyAccessContactDetails(appraisalOrderContact) {
            let propertyAccessContactDetails = 'Property Access Contact Details\n\n'

            // Property Access Contact
            if (appraisalOrderContact.contact) {
                if (appraisalOrderContact.contact.firstName && appraisalOrderContact.contact.lastName) {
                    propertyAccessContactDetails += `Name: ${appraisalOrderContact.contact.firstName} ${appraisalOrderContact.contact.lastName}\n`;
                }

                if (appraisalOrderContact.role) {
                    propertyAccessContactDetails += `Role: ${$filter('translate')('valueconnectApp.AppraisalContactRole.' + appraisalOrderContact.role)}\n`;
                }

                if (appraisalOrderContact.contact.emailAddress) {
                    propertyAccessContactDetails += `Email: ${appraisalOrderContact.contact.emailAddress}\n`;
                }

                if (appraisalOrderContact.contact.phoneNumber) {
                    propertyAccessContactDetails += `Phone: ${appraisalOrderContact.contact.phoneNumber}\n`;
                }
            }

            navigator.clipboard.writeText(propertyAccessContactDetails).then(function() {
                AlertService.success("Property access contact details copied to clipboard.");
            }).catch(function() {
                AlertService.error("Failed to copy property access contact details.");
            })
        }

        function copyUnderwriterContactDetails() {
            let underwriterContactDetails = 'Underwriter Contact Details\n\n'

            // Underwriter Contact
            if (vm.appraisalOrder.underwriterContact) {
                if (vm.appraisalOrder.underwriterContact.firstName && vm.appraisalOrder.underwriterContact.lastName) {
                    underwriterContactDetails += `Name: ${vm.appraisalOrder.underwriterContact.firstName} ${vm.appraisalOrder.underwriterContact.lastName}\n`;
                }

                if (vm.appraisalOrder.underwriterContact.emailAddress) {
                    underwriterContactDetails += `Email: ${vm.appraisalOrder.underwriterContact.emailAddress}\n`;
                }

                if (vm.appraisalOrder.underwriterContact.phoneNumber) {
                    underwriterContactDetails += `Phone: ${vm.appraisalOrder.underwriterContact.phoneNumber}\n`;
                }
            }

            navigator.clipboard.writeText(underwriterContactDetails).then(function() {
                AlertService.success("Underwriter contact details copied to clipboard.");
            }).catch(function() {
                AlertService.error("Failed to copy underwriter contact details.");
            })
        }

        function resendClientPaymentEmail() {
            // Find the client quote split
            if (vm.quote && vm.quote.quoteSplits) {
                var clientQuoteSplit = vm.quote.quoteSplits.find(function(split) {
                    return split.role === 'CLIENT' && split.splitAmount > 0;
                });

                if (clientQuoteSplit) {
                    QuoteSplit.resendClientPaymentEmail({
                        appraisalOrderId: vm.appraisalOrder.id,
                        quoteSplitId: clientQuoteSplit.id
                    }, function(data) {
                        AlertService.success("Client payment email resent successfully");
                    }, function(error) {
                        AlertService.error(error.data ? error.data.message || "Failed to resend payment email" : "Failed to resend payment email");
                    });
                } else {
                    AlertService.error("No client payment split found for this order");
                }
            } else {
                AlertService.error("No quote information available");
            }
        }

        function fetchSubmittingAgentBrokerage() {
            if (vm.appraisalOrder.submittingAgent && vm.appraisalOrder.submittingAgent.entityAuthorities) {
                let brokerageAuthority = vm.appraisalOrder.submittingAgent.entityAuthorities.find(function (authority) {
                    return authority.authorityType && authority.authorityType.startsWith('BROKERAGE');
                });

                if (brokerageAuthority) {
                    let brokerageIdPromise;
                    if (brokerageAuthority.authorityType === 'BROKERAGE') {
                        brokerageIdPromise = $q.resolve(brokerageAuthority.brokerageId);
                    } else if (brokerageAuthority.authorityType === 'BROKERAGE_LOCATION') {
                        brokerageIdPromise = BrokerageLocation.get({ id: brokerageAuthority.brokerageLocationId }).$promise.then(function (brokerageLocation) {
                            return brokerageLocation.brokerageId;
                        });
                    } else if (brokerageAuthority.authorityType === 'BROKERAGE_REGION') {
                        brokerageIdPromise = BrokerageRegion.get({ id: brokerageAuthority.brokerageRegionId }).$promise.then(function (brokerageRegion) {
                            return brokerageRegion.brokerageId;
                        });
                    }
                    
                    brokerageIdPromise.then(function (brokerageId) {
                        return Brokerage.get({ id: brokerageId }).$promise.then(function (data) {
                            vm.submittingAgentBrokerage = data.name;
                            return data;
                        });
                    });
                }
            }

            return $q.resolve(null);
        }

        function hasPlaceholderLender() {
            return vm.appraisalOrder && vm.appraisalOrder.options && 
                   vm.appraisalOrder.options.some(function(option) {
                       return option.name === 'PLACEHOLDER_LENDER';
                   });
        }

        function finalizeLender(event) {
            console.log('finalizeLender called'); // Debug log
            event.preventDefault();
            event.stopPropagation();

            // Load potential lenders from the order options
            var potentialLenders = loadPotentialLenders();
            
            if (!potentialLenders || potentialLenders.length === 0) {
                AlertService.error('No potential lenders found for this order');
                return;
            }

            // If there's only one potential lender, auto-select it without showing the popup
            if (potentialLenders.length === 1) {
                var lender = potentialLenders[0];
                console.log('Auto-selecting single potential lender:', lender.lenderName);
                
                var updateRequest = {
                    lenderId: lender.id
                };

                AppraisalOrder.finalizeLender({id: vm.appraisalOrder.id}, updateRequest)
                    .$promise
                    .then(function(response) {
                        AlertService.success('Lender "' + lender.lenderName + '" has been automatically selected');
                        $state.reload();
                    })
                    .catch(function(error) {
                        console.error('Error finalizing lender:', error);
                        var errorMessage = 'Failed to update lender';
                        if (error.data && error.data.message) {
                            errorMessage = error.data.message;
                        }
                        AlertService.error(errorMessage);
                    });
                return;
            }

            // Multiple potential lenders - show the dialog
            var modalInstance = $mdDialog.show({
                templateUrl: 'app/entities/appraisal-order/finalize-lender-dialog.html',
                controller: 'FinalizeLenderDialogController',
                controllerAs: 'vm',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    orderId: vm.appraisalOrder.id,
                    currentLender: vm.appraisalOrder.lender,
                    potentialLenders: potentialLenders, // Pass potential lenders instead of loading all
                    LenderContact: LenderContact,
                    AppraisalOrder: AppraisalOrder,
                    AlertService: AlertService
                }
            }).then(function(result) {
                if (result) {
                    // Refresh the page to show updated lender information
                    $state.reload();
                }
            }).catch(function(error) {
                // Dialog was cancelled or error occurred
                if (error !== 'cancel') {
                    console.error('Error in finalize lender dialog:', error);
                }
            });
        }

        function markRequiresEarlyPayment(event) {
            event.preventDefault();
            event.stopPropagation();
            $mdDialog.show({
                templateUrl: 'app/entities/appraisal-order/money-service-early-payout-dialog.html',
                controller: ['$mdDialog', function($mdDialog) {
                    var dialog = this;
                    dialog.paymentDueDate = new Date();
                    dialog.save = function() { $mdDialog.hide(dialog.paymentDueDate); };
                    dialog.cancel = function() { $mdDialog.cancel(); };
                }],
                controllerAs: 'dialog',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            }).then(function(paymentDueDate) {
                $http.post(
                    'api/accounting/money-service-early-payments/order/' + vm.appraisalOrder.id,
                    { paymentDueDate: moment(paymentDueDate).format('YYYY-MM-DD') }
                ).then(function() {
                    vm.hasPlootoEntry = true;
                    AlertService.success('valueconnectApp.moneyServiceEarlyPayments.orderDetail.markSuccess');
                }).catch(function(err) {
                    AlertService.error((err.data && err.data.message) || 'valueconnectApp.moneyServiceEarlyPayments.orderDetail.markError');
                });
            });
        }

        function loadPotentialLenders() {
            if (!vm.appraisalOrder || !vm.appraisalOrder.options) {
                return [];
            }

            var placeholderLenderOption = vm.appraisalOrder.options.find(function(option) {
                return option.name === 'PLACEHOLDER_LENDER';
            });

            if (placeholderLenderOption && placeholderLenderOption.value) {
                try {
                    var optionValue = JSON.parse(placeholderLenderOption.value);
                    if (optionValue.potentialLenders && Array.isArray(optionValue.potentialLenders)) {
                        // Map the potential lenders to match the expected format
                        return optionValue.potentialLenders.map(function(lender) {
                            return {
                                id: lender.id,
                                lenderName: lender.lenderName,
                                brokerageName: lender.brokerageName || null
                            };
                        });
                    }
                } catch (e) {
                    console.error('Error parsing placeholder lender options:', e);
                }
            }

            return [];
        }

        var REPORT_ACCEPTED_STATES = ['REPORT_SUBMITTED', 'REPORT_COMPLETE', 'REPORT_ACCEPTED'];

        function buildReportAvailability() {
            var order = vm.appraisalOrder;
            if (!order || !order.state) {
                return null;
            }

            var activeReport = order.activeReport;
            if (!activeReport || !activeReport.id) {
                return null;
            }

            var activeReportId = activeReport.id;

            if (REPORT_ACCEPTED_STATES.indexOf(order.state) !== -1) {
                return {
                    variant: 'green',
                    labelKey: 'valueconnectApp.appraisalOrder.reportAvailability.submitted',
                    linkType: 'review',
                    activeReportId: activeReportId
                };
            }

            if (order.hasThirdPartyReportUploaded) {
                return {
                    variant: order.reportSentToOriginatorOnly ? 'green' : 'red',
                    labelKey: order.reportSentToOriginatorOnly
                        ? 'valueconnectApp.appraisalOrder.reportAvailability.sentToOriginator'
                        : 'valueconnectApp.appraisalOrder.reportAvailability.uploadedNotSubmitted',
                    linkType: 'thirdPartyBuilder',
                    activeReportId: activeReportId
                };
            }

            return null;
        }
    }

})();
